import React from "react";

const Footer = () => {
    return (
        <>
            <div className="foot_style">
                <h1 className="made_with">Made with ❤️</h1>
            </div>
        </>
    );
}

export default Footer;
